// define all images
const images = {
  novocallLogo: require('../assets/images/icon_novocall.png'),
  spinner: require('../assets/images/spinner.gif'),
  checkIcon: require('../assets/images/icons/check.svg'),
  errorIcon: require('../assets/images/icons/error.svg'),
  infoIcon: require('../assets/images/icons/info.svg'),
  warningIcon: require('../assets/images/icons/warning.svg'),
};

export default images; 